<template>
	<button type="button" class="fac-card-tab-button" @click.prevent="open" :class="status ? 'active' : '' ">
        <!-- @slot Para inserir o texto do botão -->
        <slot />
    </button>
</template>
<script>
	export default {
        name: 'ui-card-tab-button',
        props: {
            content: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
				status: false,
            }
		},
		methods:{
			open(){
                this.$parent.$emit("open", this.content);
            },
            check(current){
				if(current === this.content){
                    this.status = true
                    return 
                }
                
                this.status = false
            },
        },
        mounted(){
			this.$parent.$on("current", this.check)
		}
    };
</script>

<style lang="stylus" scoped>
    @import '../styles.styl';
</style>

